export const FEMALE_TITAN_TABLE_CONFIG = {
  "sourceWorkbook": "reference-data/aoz/aoz-fleet.xlsx",
  "sourceSheet": "Female Titan Table",
  "extractedAt": "2026-03-11T00:50:26Z",
  "notes": [
    "Tier table extracted from rows 1-34 (Tier 1-3 columns B-AA).",
    "Level table extracted from rows 88-133 (Titan Level progression).",
    "Values are parsed directly from sheet cells; blanks omitted."
  ],
  "tierStatsByTierAndLevel": {
    "1": {
      "1": {
        "alloys": 0,
        "titan_attack": 23000,
        "titan_hp": 420000,
        "titan_defense": 2,
        "increase_troops_attack": 0.8,
        "increase_troops_hp_and_defense": 1,
        "empress_escort_required_components": 20,
        "empress_escort_titan_equipment_chip": 45,
        "empress_escort": 8.4
      },
      "2": {
        "alloys": 15,
        "titan_attack": 46000,
        "titan_hp": 840000,
        "titan_defense": 3,
        "increase_troops_attack": 1.6,
        "increase_troops_hp_and_defense": 2,
        "empress_escort_required_components": 20,
        "empress_escort_titan_equipment_chip": 15,
        "empress_escort": 9.6
      },
      "3": {
        "alloys": 23,
        "titan_attack": 69000,
        "titan_hp": 1260000,
        "titan_defense": 5,
        "increase_troops_attack": 2.4,
        "increase_troops_hp_and_defense": 3,
        "empress_escort_required_components": 24,
        "empress_escort_titan_equipment_chip": 20,
        "empress_escort": 10.8
      },
      "4": {
        "alloys": 32,
        "titan_attack": 92000,
        "titan_hp": 1680000,
        "titan_defense": 6,
        "increase_troops_attack": 3.2,
        "increase_troops_hp_and_defense": 4,
        "empress_escort_required_components": 28,
        "empress_escort_titan_equipment_chip": 25,
        "empress_escort": 12
      },
      "5": {
        "alloys": 41,
        "titan_attack": 115000,
        "titan_hp": 2100000,
        "titan_defense": 8,
        "increase_troops_attack": 4,
        "increase_troops_hp_and_defense": 5,
        "empress_escort_required_components": 32,
        "empress_escort_titan_equipment_chip": 33,
        "empress_escort": 13.2
      },
      "6": {
        "alloys": 57,
        "titan_attack": 138000,
        "titan_hp": 2520000,
        "titan_defense": 9,
        "increase_troops_attack": 4.8,
        "increase_troops_hp_and_defense": 6,
        "empress_escort_required_components": 36,
        "empress_escort_titan_equipment_chip": 41,
        "empress_escort": 14.4
      },
      "7": {
        "alloys": 75,
        "titan_attack": 161000,
        "titan_hp": 2940000,
        "titan_defense": 11,
        "increase_troops_attack": 5.6,
        "increase_troops_hp_and_defense": 7,
        "empress_escort_required_components": 40,
        "empress_escort_titan_equipment_chip": 50,
        "empress_escort": 15.6
      },
      "8": {
        "alloys": 89,
        "titan_attack": 184000,
        "titan_hp": 3360000,
        "titan_defense": 12,
        "increase_troops_attack": 6.4,
        "increase_troops_hp_and_defense": 8,
        "empress_escort_required_components": 44,
        "empress_escort_titan_equipment_chip": 58,
        "empress_escort": 16.8
      },
      "9": {
        "alloys": 104,
        "titan_attack": 207000,
        "titan_hp": 3780000,
        "titan_defense": 14,
        "increase_troops_attack": 7.2,
        "increase_troops_hp_and_defense": 9,
        "empress_escort_required_components": 48,
        "empress_escort_titan_equipment_chip": 65,
        "empress_escort": 18
      },
      "10": {
        "alloys": 118,
        "titan_attack": 230000,
        "titan_hp": 4200000,
        "titan_defense": 15,
        "increase_troops_attack": 8,
        "increase_troops_hp_and_defense": 10,
        "empress_escort_required_components": 52,
        "empress_escort_titan_equipment_chip": 71,
        "empress_escort": 19.2
      },
      "11": {
        "alloys": 135,
        "titan_attack": 253000,
        "titan_hp": 4620000,
        "titan_defense": 17,
        "increase_troops_attack": 8.8,
        "increase_troops_hp_and_defense": 11,
        "empress_escort_required_components": 56,
        "empress_escort_titan_equipment_chip": 78,
        "empress_escort": 20.4
      },
      "12": {
        "alloys": 154,
        "titan_attack": 276000,
        "titan_hp": 5040000,
        "titan_defense": 18,
        "increase_troops_attack": 9.6,
        "increase_troops_hp_and_defense": 12,
        "empress_escort_required_components": 60,
        "empress_escort_titan_equipment_chip": 87,
        "empress_escort": 21.6
      },
      "13": {
        "alloys": 171,
        "titan_attack": 299000,
        "titan_hp": 5460000,
        "titan_defense": 20,
        "increase_troops_attack": 10.4,
        "increase_troops_hp_and_defense": 13,
        "empress_escort_required_components": 64,
        "empress_escort_titan_equipment_chip": 98,
        "empress_escort": 22.8
      },
      "14": {
        "alloys": 188,
        "titan_attack": 322000,
        "titan_hp": 5880000,
        "titan_defense": 21,
        "increase_troops_attack": 11.2,
        "increase_troops_hp_and_defense": 14,
        "empress_escort_required_components": 68,
        "empress_escort_titan_equipment_chip": 110,
        "empress_escort": 24
      },
      "15": {
        "alloys": 203,
        "titan_attack": 345000,
        "titan_hp": 6300000,
        "titan_defense": 23,
        "increase_troops_attack": 12,
        "increase_troops_hp_and_defense": 15,
        "empress_escort_required_components": 72,
        "empress_escort_titan_equipment_chip": 132,
        "empress_escort": 25.2
      },
      "16": {
        "alloys": 219,
        "titan_attack": 368000,
        "titan_hp": 6720000,
        "titan_defense": 24,
        "increase_troops_attack": 12.8,
        "increase_troops_hp_and_defense": 16,
        "empress_escort_required_components": 76,
        "empress_escort_titan_equipment_chip": 145,
        "empress_escort": 26.4
      },
      "17": {
        "alloys": 236,
        "titan_attack": 391000,
        "titan_hp": 7140000,
        "titan_defense": 26,
        "increase_troops_attack": 13.6,
        "increase_troops_hp_and_defense": 17,
        "empress_escort_required_components": 80,
        "empress_escort_titan_equipment_chip": 154,
        "empress_escort": 27.6
      },
      "18": {
        "alloys": 255,
        "titan_attack": 414000,
        "titan_hp": 7560000,
        "titan_defense": 27,
        "increase_troops_attack": 14.4,
        "increase_troops_hp_and_defense": 18,
        "empress_escort_required_components": 84,
        "empress_escort_titan_equipment_chip": 163,
        "empress_escort": 28.8
      },
      "19": {
        "alloys": 276,
        "titan_attack": 437000,
        "titan_hp": 7980000,
        "titan_defense": 29,
        "increase_troops_attack": 15.2,
        "increase_troops_hp_and_defense": 19,
        "empress_escort_required_components": 88,
        "empress_escort_titan_equipment_chip": 172,
        "empress_escort": 30
      },
      "20": {
        "alloys": 298,
        "titan_attack": 460000,
        "titan_hp": 8400000,
        "titan_defense": 30,
        "increase_troops_attack": 16,
        "increase_troops_hp_and_defense": 20,
        "empress_escort_required_components": 92,
        "empress_escort_titan_equipment_chip": 183,
        "empress_escort": 31.2
      },
      "21": {
        "alloys": 322,
        "titan_attack": 483000,
        "titan_hp": 8820000,
        "titan_defense": 32,
        "increase_troops_attack": 16.8,
        "increase_troops_hp_and_defense": 21,
        "empress_escort_required_components": 96,
        "empress_escort_titan_equipment_chip": 202,
        "empress_escort": 32.4
      },
      "22": {
        "alloys": 354,
        "titan_attack": 506000,
        "titan_hp": 9240000,
        "titan_defense": 33,
        "increase_troops_attack": 17.6,
        "increase_troops_hp_and_defense": 22,
        "empress_escort_required_components": 100,
        "empress_escort_titan_equipment_chip": 222,
        "empress_escort": 33.6
      },
      "23": {
        "alloys": 389,
        "titan_attack": 529000,
        "titan_hp": 9660000,
        "titan_defense": 35,
        "increase_troops_attack": 18.4,
        "increase_troops_hp_and_defense": 23,
        "empress_escort_required_components": 104,
        "empress_escort_titan_equipment_chip": 244,
        "empress_escort": 34.8
      },
      "24": {
        "alloys": 428,
        "titan_attack": 552000,
        "titan_hp": 10080000,
        "titan_defense": 36,
        "increase_troops_attack": 19.2,
        "increase_troops_hp_and_defense": 24,
        "empress_escort_required_components": 108,
        "empress_escort_titan_equipment_chip": 268,
        "empress_escort": 36
      },
      "25": {
        "alloys": 479,
        "titan_attack": 575000,
        "titan_hp": 10500000,
        "titan_defense": 38,
        "increase_troops_attack": 20,
        "increase_troops_hp_and_defense": 25,
        "empress_escort_required_components": 112,
        "empress_escort_titan_equipment_chip": 295,
        "empress_escort": 37.2
      },
      "26": {
        "alloys": 537,
        "titan_attack": 598000,
        "titan_hp": 10920000,
        "titan_defense": 39,
        "increase_troops_attack": 20.8,
        "increase_troops_hp_and_defense": 26,
        "empress_escort_required_components": 116,
        "empress_escort_titan_equipment_chip": 325,
        "empress_escort": 38.4
      },
      "27": {
        "alloys": 601,
        "titan_attack": 621000,
        "titan_hp": 11340000,
        "titan_defense": 41,
        "increase_troops_attack": 21.6,
        "increase_troops_hp_and_defense": 27
      },
      "28": {
        "alloys": 674,
        "titan_attack": 644000,
        "titan_hp": 11760000,
        "titan_defense": 42,
        "increase_troops_attack": 22.4,
        "increase_troops_hp_and_defense": 28
      },
      "29": {
        "alloys": 754,
        "titan_attack": 667000,
        "titan_hp": 12180000,
        "titan_defense": 44,
        "increase_troops_attack": 23.2,
        "increase_troops_hp_and_defense": 29
      },
      "30": {
        "alloys": 845,
        "titan_attack": 690000,
        "titan_hp": 12600000,
        "titan_defense": 45,
        "increase_troops_attack": 24,
        "increase_troops_hp_and_defense": 30
      }
    },
    "2": {
      "1": {
        "alloys": 0,
        "titan_attack": 23000,
        "titan_hp": 420000,
        "titan_defense": 2,
        "attack_against_mid_range_boost": 1.8,
        "attack_against_long_range_boost": 1.8,
        "steel_barrier": 4,
        "steel_barrier_required_components": 40,
        "steel_barrier_titan_equipment_chip": 90
      },
      "2": {
        "alloys": 23,
        "titan_attack": 46000,
        "titan_hp": 840000,
        "titan_defense": 3,
        "attack_against_mid_range_boost": 3.6,
        "attack_against_long_range_boost": 3.6,
        "steel_barrier": 4.8,
        "steel_barrier_required_components": 40,
        "steel_barrier_titan_equipment_chip": 23
      },
      "3": {
        "alloys": 34,
        "titan_attack": 69000,
        "titan_hp": 1260000,
        "titan_defense": 5,
        "attack_against_mid_range_boost": 5.4,
        "attack_against_long_range_boost": 5.4,
        "steel_barrier": 5.6,
        "steel_barrier_required_components": 40,
        "steel_barrier_titan_equipment_chip": 29
      },
      "4": {
        "alloys": 47,
        "titan_attack": 92000,
        "titan_hp": 1680000,
        "titan_defense": 6,
        "attack_against_mid_range_boost": 7.2,
        "attack_against_long_range_boost": 7.2,
        "steel_barrier": 6.4,
        "steel_barrier_required_components": 40,
        "steel_barrier_titan_equipment_chip": 38
      },
      "5": {
        "alloys": 61,
        "titan_attack": 115000,
        "titan_hp": 2100000,
        "titan_defense": 8,
        "attack_against_mid_range_boost": 9,
        "attack_against_long_range_boost": 9,
        "steel_barrier": 7.2,
        "steel_barrier_required_components": 40,
        "steel_barrier_titan_equipment_chip": 49
      },
      "6": {
        "alloys": 86,
        "titan_attack": 138000,
        "titan_hp": 2520000,
        "titan_defense": 9,
        "attack_against_mid_range_boost": 10.8,
        "attack_against_long_range_boost": 10.8,
        "steel_barrier": 8,
        "steel_barrier_required_components": 40,
        "steel_barrier_titan_equipment_chip": 61
      },
      "7": {
        "alloys": 112,
        "titan_attack": 161000,
        "titan_hp": 2940000,
        "titan_defense": 11,
        "attack_against_mid_range_boost": 12.6,
        "attack_against_long_range_boost": 12.6,
        "steel_barrier": 8.8,
        "steel_barrier_required_components": 40,
        "steel_barrier_titan_equipment_chip": 75
      },
      "8": {
        "alloys": 134,
        "titan_attack": 184000,
        "titan_hp": 3360000,
        "titan_defense": 12,
        "attack_against_mid_range_boost": 14.4,
        "attack_against_long_range_boost": 14.4,
        "steel_barrier": 9.6,
        "steel_barrier_required_components": 44,
        "steel_barrier_titan_equipment_chip": 86
      },
      "9": {
        "alloys": 156,
        "titan_attack": 207000,
        "titan_hp": 3780000,
        "titan_defense": 14,
        "attack_against_mid_range_boost": 16.2,
        "attack_against_long_range_boost": 16.2,
        "steel_barrier": 10.4,
        "steel_barrier_required_components": 48,
        "steel_barrier_titan_equipment_chip": 97
      },
      "10": {
        "alloys": 177,
        "titan_attack": 230000,
        "titan_hp": 4200000,
        "titan_defense": 15,
        "attack_against_mid_range_boost": 18,
        "attack_against_long_range_boost": 18,
        "steel_barrier": 11.2,
        "steel_barrier_required_components": 52,
        "steel_barrier_titan_equipment_chip": 106
      },
      "11": {
        "alloys": 202,
        "titan_attack": 253000,
        "titan_hp": 4620000,
        "titan_defense": 17,
        "attack_against_mid_range_boost": 19.8,
        "attack_against_long_range_boost": 19.8,
        "steel_barrier": 12,
        "steel_barrier_required_components": 56,
        "steel_barrier_titan_equipment_chip": 112
      },
      "12": {
        "alloys": 231,
        "titan_attack": 276000,
        "titan_hp": 5040000,
        "titan_defense": 18,
        "attack_against_mid_range_boost": 21.6,
        "attack_against_long_range_boost": 21.6,
        "steel_barrier": 12.8,
        "steel_barrier_required_components": 60,
        "steel_barrier_titan_equipment_chip": 119
      },
      "13": {
        "alloys": 256,
        "titan_attack": 299000,
        "titan_hp": 5460000,
        "titan_defense": 20,
        "attack_against_mid_range_boost": 23.4,
        "attack_against_long_range_boost": 23.4,
        "steel_barrier": 13.6,
        "steel_barrier_required_components": 64,
        "steel_barrier_titan_equipment_chip": 126
      },
      "14": {
        "alloys": 282,
        "titan_attack": 322000,
        "titan_hp": 5880000,
        "titan_defense": 21,
        "attack_against_mid_range_boost": 25.2,
        "attack_against_long_range_boost": 25.2,
        "steel_barrier": 14.4,
        "steel_barrier_required_components": 68,
        "steel_barrier_titan_equipment_chip": 133
      },
      "15": {
        "alloys": 304,
        "titan_attack": 345000,
        "titan_hp": 6300000,
        "titan_defense": 23,
        "attack_against_mid_range_boost": 27,
        "attack_against_long_range_boost": 27,
        "steel_barrier": 15.2,
        "steel_barrier_required_components": 72,
        "steel_barrier_titan_equipment_chip": 141
      },
      "16": {
        "alloys": 322,
        "titan_attack": 368000,
        "titan_hp": 6720000,
        "titan_defense": 24,
        "attack_against_mid_range_boost": 28.8,
        "attack_against_long_range_boost": 28.8,
        "steel_barrier": 16,
        "steel_barrier_required_components": 76,
        "steel_barrier_titan_equipment_chip": 150
      },
      "17": {
        "alloys": 342,
        "titan_attack": 391000,
        "titan_hp": 7140000,
        "titan_defense": 26,
        "attack_against_mid_range_boost": 30.6,
        "attack_against_long_range_boost": 30.6,
        "steel_barrier": 16.8,
        "steel_barrier_required_components": 80,
        "steel_barrier_titan_equipment_chip": 159
      },
      "18": {
        "alloys": 362,
        "titan_attack": 414000,
        "titan_hp": 7560000,
        "titan_defense": 27,
        "attack_against_mid_range_boost": 32.4,
        "attack_against_long_range_boost": 32.4,
        "steel_barrier": 17.6,
        "steel_barrier_required_components": 84,
        "steel_barrier_titan_equipment_chip": 168
      },
      "19": {
        "alloys": 384,
        "titan_attack": 437000,
        "titan_hp": 7980000,
        "titan_defense": 29,
        "attack_against_mid_range_boost": 34.2,
        "attack_against_long_range_boost": 34.2,
        "steel_barrier": 18.4,
        "steel_barrier_required_components": 88,
        "steel_barrier_titan_equipment_chip": 178
      },
      "20": {
        "alloys": 407,
        "titan_attack": 460000,
        "titan_hp": 8400000,
        "titan_defense": 30,
        "attack_against_mid_range_boost": 36,
        "attack_against_long_range_boost": 36,
        "steel_barrier": 19.2,
        "steel_barrier_required_components": 92,
        "steel_barrier_titan_equipment_chip": 189
      },
      "21": {
        "alloys": 431,
        "titan_attack": 483000,
        "titan_hp": 8820000,
        "titan_defense": 32,
        "attack_against_mid_range_boost": 37.8,
        "attack_against_long_range_boost": 37.8,
        "steel_barrier": 20,
        "steel_barrier_required_components": 96,
        "steel_barrier_titan_equipment_chip": 204
      },
      "22": {
        "alloys": 457,
        "titan_attack": 506000,
        "titan_hp": 9240000,
        "titan_defense": 33,
        "attack_against_mid_range_boost": 39.6,
        "attack_against_long_range_boost": 39.6,
        "steel_barrier": 20.8,
        "steel_barrier_required_components": 100,
        "steel_barrier_titan_equipment_chip": 220
      },
      "23": {
        "alloys": 485,
        "titan_attack": 529000,
        "titan_hp": 9660000,
        "titan_defense": 35,
        "attack_against_mid_range_boost": 41.4,
        "attack_against_long_range_boost": 41.4,
        "steel_barrier": 21.6,
        "steel_barrier_required_components": 104,
        "steel_barrier_titan_equipment_chip": 238
      },
      "24": {
        "alloys": 514,
        "titan_attack": 552000,
        "titan_hp": 10080000,
        "titan_defense": 36,
        "attack_against_mid_range_boost": 43.2,
        "attack_against_long_range_boost": 43.2,
        "steel_barrier": 22.4,
        "steel_barrier_required_components": 108,
        "steel_barrier_titan_equipment_chip": 257
      },
      "25": {
        "alloys": 544,
        "titan_attack": 575000,
        "titan_hp": 10500000,
        "titan_defense": 38,
        "attack_against_mid_range_boost": 45,
        "attack_against_long_range_boost": 45,
        "steel_barrier": 23.2,
        "steel_barrier_required_components": 112,
        "steel_barrier_titan_equipment_chip": 278
      },
      "26": {
        "alloys": 599,
        "titan_attack": 598000,
        "titan_hp": 10920000,
        "titan_defense": 39,
        "attack_against_mid_range_boost": 46.8,
        "attack_against_long_range_boost": 46.8,
        "steel_barrier": 24,
        "steel_barrier_required_components": 116,
        "steel_barrier_titan_equipment_chip": 300
      },
      "27": {
        "alloys": 659,
        "titan_attack": 621000,
        "titan_hp": 11340000,
        "titan_defense": 41,
        "attack_against_mid_range_boost": 48.6,
        "attack_against_long_range_boost": 48.6
      },
      "28": {
        "alloys": 725,
        "titan_attack": 644000,
        "titan_hp": 11760000,
        "titan_defense": 42,
        "attack_against_mid_range_boost": 50.4,
        "attack_against_long_range_boost": 50.4
      },
      "29": {
        "alloys": 797,
        "titan_attack": 667000,
        "titan_hp": 12180000,
        "titan_defense": 44,
        "attack_against_mid_range_boost": 52.2,
        "attack_against_long_range_boost": 52.2
      },
      "30": {
        "alloys": 877,
        "titan_attack": 690000,
        "titan_hp": 12600000,
        "titan_defense": 45,
        "attack_against_mid_range_boost": 54,
        "attack_against_long_range_boost": 54
      }
    },
    "3": {
      "1": {
        "alloys": 0,
        "increase_titan_damage_against_lr_troops": 0.8,
        "increase_damage_of_bloodfeast": 1.3,
        "zombies_army_limit": 200,
        "increase_attack_against_meele_troops": 1.8,
        "toxic_tail": 18.5,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 180
      },
      "2": {
        "alloys": 30,
        "increase_titan_damage_against_lr_troops": 1.6,
        "increase_damage_of_bloodfeast": 2.6,
        "zombies_army_limit": 400,
        "increase_attack_against_meele_troops": 3.6,
        "toxic_tail": 22.2,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 34
      },
      "3": {
        "alloys": 45,
        "increase_titan_damage_against_lr_troops": 2.4,
        "increase_damage_of_bloodfeast": 3.9,
        "zombies_army_limit": 600,
        "increase_attack_against_meele_troops": 5.4,
        "toxic_tail": 25.9,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 44
      },
      "4": {
        "alloys": 63,
        "increase_titan_damage_against_lr_troops": 3.2,
        "increase_damage_of_bloodfeast": 5.2,
        "zombies_army_limit": 800,
        "increase_attack_against_meele_troops": 7.2,
        "toxic_tail": 29.6,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 57
      },
      "5": {
        "alloys": 82,
        "increase_titan_damage_against_lr_troops": 4,
        "increase_damage_of_bloodfeast": 6.5,
        "zombies_army_limit": 1000,
        "increase_attack_against_meele_troops": 9,
        "toxic_tail": 33.3,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 73
      },
      "6": {
        "alloys": 115,
        "increase_titan_damage_against_lr_troops": 4.8,
        "increase_damage_of_bloodfeast": 7.8,
        "zombies_army_limit": 1200,
        "increase_attack_against_meele_troops": 10.8,
        "toxic_tail": 37,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 92
      },
      "7": {
        "alloys": 149,
        "increase_titan_damage_against_lr_troops": 5.6,
        "increase_damage_of_bloodfeast": 9.1,
        "zombies_army_limit": 1400,
        "increase_attack_against_meele_troops": 12.6,
        "toxic_tail": 40.7,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 112
      },
      "8": {
        "alloys": 179,
        "increase_titan_damage_against_lr_troops": 6.4,
        "increase_damage_of_bloodfeast": 10.4,
        "zombies_army_limit": 1600,
        "increase_attack_against_meele_troops": 14.4,
        "toxic_tail": 44.4,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 130
      },
      "9": {
        "alloys": 207,
        "increase_titan_damage_against_lr_troops": 7.2,
        "increase_damage_of_bloodfeast": 11.7,
        "zombies_army_limit": 1800,
        "increase_attack_against_meele_troops": 16.2,
        "toxic_tail": 48.1,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 145
      },
      "10": {
        "alloys": 237,
        "increase_titan_damage_against_lr_troops": 8,
        "increase_damage_of_bloodfeast": 13,
        "zombies_army_limit": 2000,
        "increase_attack_against_meele_troops": 18,
        "toxic_tail": 51.8,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 158
      },
      "11": {
        "alloys": 270,
        "increase_titan_damage_against_lr_troops": 8.8,
        "increase_damage_of_bloodfeast": 14.3,
        "zombies_army_limit": 2200,
        "increase_attack_against_meele_troops": 19.8,
        "toxic_tail": 55.5,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 168
      },
      "12": {
        "alloys": 307,
        "increase_titan_damage_against_lr_troops": 9.6,
        "increase_damage_of_bloodfeast": 15.6,
        "zombies_army_limit": 2400,
        "increase_attack_against_meele_troops": 21.6,
        "toxic_tail": 59.2,
        "toxic_tail_required_components": 60,
        "toxic_tail_titan_equipment_chip": 178
      },
      "13": {
        "alloys": 341,
        "increase_titan_damage_against_lr_troops": 10.4,
        "increase_damage_of_bloodfeast": 16.9,
        "zombies_army_limit": 2600,
        "increase_attack_against_meele_troops": 23.4,
        "toxic_tail": 62.9,
        "toxic_tail_required_components": 64,
        "toxic_tail_titan_equipment_chip": 189
      },
      "14": {
        "alloys": 375,
        "increase_titan_damage_against_lr_troops": 11.2,
        "increase_damage_of_bloodfeast": 18.2,
        "zombies_army_limit": 2800,
        "increase_attack_against_meele_troops": 25.2,
        "toxic_tail": 66.6,
        "toxic_tail_required_components": 68,
        "toxic_tail_titan_equipment_chip": 200
      },
      "15": {
        "alloys": 405,
        "increase_titan_damage_against_lr_troops": 12,
        "increase_damage_of_bloodfeast": 19.5,
        "zombies_army_limit": 3000,
        "increase_attack_against_meele_troops": 27,
        "toxic_tail": 70.3,
        "toxic_tail_required_components": 72,
        "toxic_tail_titan_equipment_chip": 212
      },
      "16": {
        "alloys": 430,
        "increase_titan_damage_against_lr_troops": 12.8,
        "increase_damage_of_bloodfeast": 20.8,
        "zombies_army_limit": 3200,
        "increase_attack_against_meele_troops": 28.8,
        "toxic_tail": 74,
        "toxic_tail_required_components": 76,
        "toxic_tail_titan_equipment_chip": 225
      },
      "17": {
        "alloys": 455,
        "increase_titan_damage_against_lr_troops": 13.6,
        "increase_damage_of_bloodfeast": 22.1,
        "zombies_army_limit": 3400,
        "increase_attack_against_meele_troops": 30.6,
        "toxic_tail": 77.7,
        "toxic_tail_required_components": 80,
        "toxic_tail_titan_equipment_chip": 238
      },
      "18": {
        "alloys": 483,
        "increase_titan_damage_against_lr_troops": 14.4,
        "increase_damage_of_bloodfeast": 23.4,
        "zombies_army_limit": 3600,
        "increase_attack_against_meele_troops": 32.4,
        "toxic_tail": 81.4,
        "toxic_tail_required_components": 84,
        "toxic_tail_titan_equipment_chip": 252
      },
      "19": {
        "alloys": 512,
        "increase_titan_damage_against_lr_troops": 15.2,
        "increase_damage_of_bloodfeast": 24.7,
        "zombies_army_limit": 3800,
        "increase_attack_against_meele_troops": 34.2,
        "toxic_tail": 85.1,
        "toxic_tail_required_components": 88,
        "toxic_tail_titan_equipment_chip": 267
      },
      "20": {
        "alloys": 542,
        "increase_titan_damage_against_lr_troops": 16,
        "increase_damage_of_bloodfeast": 26,
        "zombies_army_limit": 4000,
        "increase_attack_against_meele_troops": 36,
        "toxic_tail": 88.8,
        "toxic_tail_required_components": 92,
        "toxic_tail_titan_equipment_chip": 283
      },
      "21": {
        "alloys": 575,
        "increase_titan_damage_against_lr_troops": 16.8,
        "increase_damage_of_bloodfeast": 27.3,
        "zombies_army_limit": 4200,
        "increase_attack_against_meele_troops": 37.8,
        "toxic_tail": 92.5,
        "toxic_tail_required_components": 96,
        "toxic_tail_titan_equipment_chip": 306
      },
      "22": {
        "alloys": 610,
        "increase_titan_damage_against_lr_troops": 17.6,
        "increase_damage_of_bloodfeast": 28.6,
        "zombies_army_limit": 4400,
        "increase_attack_against_meele_troops": 39.6,
        "toxic_tail": 96.2,
        "toxic_tail_required_components": 100,
        "toxic_tail_titan_equipment_chip": 331
      },
      "23": {
        "alloys": 646,
        "increase_titan_damage_against_lr_troops": 18.4,
        "increase_damage_of_bloodfeast": 29.9,
        "zombies_army_limit": 4600,
        "increase_attack_against_meele_troops": 41.4,
        "toxic_tail": 99.9,
        "toxic_tail_required_components": 104,
        "toxic_tail_titan_equipment_chip": 357
      },
      "24": {
        "alloys": 685,
        "increase_titan_damage_against_lr_troops": 19.2,
        "increase_damage_of_bloodfeast": 31.2,
        "zombies_army_limit": 4800,
        "increase_attack_against_meele_troops": 43.2,
        "toxic_tail": 103.6,
        "toxic_tail_required_components": 108,
        "toxic_tail_titan_equipment_chip": 386
      },
      "25": {
        "alloys": 726,
        "increase_titan_damage_against_lr_troops": 20,
        "increase_damage_of_bloodfeast": 32.5,
        "zombies_army_limit": 5000,
        "increase_attack_against_meele_troops": 45,
        "toxic_tail": 107.3,
        "toxic_tail_required_components": 112,
        "toxic_tail_titan_equipment_chip": 416
      },
      "26": {
        "alloys": 799,
        "increase_titan_damage_against_lr_troops": 20.8,
        "increase_damage_of_bloodfeast": 33.8,
        "zombies_army_limit": 5200,
        "increase_attack_against_meele_troops": 46.8,
        "toxic_tail": 111,
        "toxic_tail_required_components": 116,
        "toxic_tail_titan_equipment_chip": 450
      },
      "27": {
        "alloys": 878,
        "increase_titan_damage_against_lr_troops": 21.6,
        "increase_damage_of_bloodfeast": 35.1,
        "zombies_army_limit": 5400,
        "increase_attack_against_meele_troops": 48.6
      },
      "28": {
        "alloys": 966,
        "increase_titan_damage_against_lr_troops": 22.4,
        "increase_damage_of_bloodfeast": 36.4,
        "zombies_army_limit": 5600,
        "increase_attack_against_meele_troops": 50.4
      },
      "29": {
        "alloys": 1063,
        "increase_titan_damage_against_lr_troops": 23.2,
        "increase_damage_of_bloodfeast": 37.7,
        "zombies_army_limit": 5800,
        "increase_attack_against_meele_troops": 52.2
      },
      "30": {
        "alloys": 1169,
        "increase_titan_damage_against_lr_troops": 24,
        "increase_damage_of_bloodfeast": 39,
        "zombies_army_limit": 6000,
        "increase_attack_against_meele_troops": 54
      }
    }
  },
  "levelProgression": [
    {
      "titanLevel": 1,
      "xp": 0,
      "xpCumulative": 0,
      "attack": 292000,
      "hp": 2256800,
      "defense": 23,
      "attackCumulative": 292000,
      "hpCumulative": 2256800,
      "defenseCumulative": 23,
      "tierPhase": "Green",
      "tierLevel": 0,
      "phaseAttack": 0,
      "phaseHp": 0,
      "phaseDefense": 0,
      "phaseAttackCumulative": 0,
      "phaseHpCumulative": 0,
      "phaseDefenseCumulative": 0,
      "phaseAndLevel": "Green0"
    },
    {
      "titanLevel": 2,
      "xp": 500,
      "xpCumulative": 500,
      "attack": 31510,
      "hp": 336595,
      "defense": 2,
      "attackCumulative": 323510,
      "hpCumulative": 2593395,
      "defenseCumulative": 25,
      "tierPhase": "Green",
      "tierLevel": 1,
      "phaseAttack": 27359,
      "phaseHp": 402854,
      "phaseDefense": 2,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green1"
    },
    {
      "titanLevel": 3,
      "xp": 1200,
      "xpCumulative": 1700,
      "attack": 34911,
      "hp": 386797,
      "defense": 3,
      "attackCumulative": 358421,
      "hpCumulative": 2980192,
      "defenseCumulative": 28,
      "tierPhase": "Green",
      "tierLevel": 2,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green2"
    },
    {
      "titanLevel": 4,
      "xp": 2200,
      "xpCumulative": 3900,
      "attack": 38678,
      "hp": 444487,
      "defense": 3,
      "attackCumulative": 397099,
      "hpCumulative": 3424679,
      "defenseCumulative": 31,
      "tierPhase": "Green",
      "tierLevel": 3,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green3"
    },
    {
      "titanLevel": 5,
      "xp": 3700,
      "xpCumulative": 7600,
      "attack": 42852,
      "hp": 510781,
      "defense": 3,
      "attackCumulative": 439951,
      "hpCumulative": 3935460,
      "defenseCumulative": 34,
      "tierPhase": "Green",
      "tierLevel": 4,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green4"
    },
    {
      "titanLevel": 6,
      "xp": 5800,
      "xpCumulative": 13400,
      "defense": 3,
      "defenseCumulative": 37,
      "tierPhase": "Green",
      "tierLevel": 5,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green5"
    },
    {
      "titanLevel": 7,
      "xp": 8700,
      "xpCumulative": 22100,
      "defense": 3,
      "defenseCumulative": 40,
      "tierPhase": "Green",
      "tierLevel": 6,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green6"
    },
    {
      "titanLevel": 8,
      "xp": 12600,
      "xpCumulative": 34700,
      "defense": 4,
      "attackCumulative": 585704,
      "hpCumulative": 5658124,
      "defenseCumulative": 44,
      "tierPhase": "Green",
      "tierLevel": 7,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green7"
    },
    {
      "titanLevel": 9,
      "xp": 17800,
      "xpCumulative": 52500,
      "attack": 58618,
      "hp": 727914,
      "defense": 4,
      "attackCumulative": 644322,
      "hpCumulative": 6386038,
      "defenseCumulative": 48,
      "tierPhase": "Green",
      "tierLevel": 8,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green8"
    },
    {
      "titanLevel": 10,
      "xp": 24400,
      "xpCumulative": 76900,
      "attack": 64484,
      "hp": 821559,
      "defense": 5,
      "attackCumulative": 708806,
      "hpCumulative": 7207597,
      "defenseCumulative": 53,
      "tierPhase": "Green",
      "tierLevel": 9,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Green9"
    },
    {
      "titanLevel": 11,
      "xp": 33000,
      "xpCumulative": 109900,
      "tierPhase": "Blue",
      "tierLevel": 0,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue0"
    },
    {
      "titanLevel": 12,
      "xp": 43800,
      "xpCumulative": 153700,
      "tierPhase": "Blue",
      "tierLevel": 1,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue1"
    },
    {
      "titanLevel": 13,
      "xp": 57400,
      "xpCumulative": 211100,
      "tierPhase": "Blue",
      "tierLevel": 2,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue2"
    },
    {
      "titanLevel": 14,
      "xp": 74300,
      "xpCumulative": 285400,
      "tierPhase": "Blue",
      "tierLevel": 3,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue3"
    },
    {
      "titanLevel": 15,
      "xp": 95100,
      "xpCumulative": 380500,
      "tierPhase": "Blue",
      "tierLevel": 4,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue4"
    },
    {
      "titanLevel": 16,
      "xp": 115900,
      "xpCumulative": 496400,
      "tierPhase": "Blue",
      "tierLevel": 5,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue5"
    },
    {
      "titanLevel": 17,
      "xp": 139700,
      "xpCumulative": 636100,
      "tierPhase": "Blue",
      "tierLevel": 6,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue6"
    },
    {
      "titanLevel": 18,
      "xp": 166800,
      "xpCumulative": 802900,
      "tierPhase": "Blue",
      "tierLevel": 7,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue7"
    },
    {
      "titanLevel": 19,
      "xp": 197300,
      "xpCumulative": 1000200,
      "tierPhase": "Blue",
      "tierLevel": 8,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue8"
    },
    {
      "titanLevel": 20,
      "xp": 231400,
      "xpCumulative": 1231600,
      "tierPhase": "Blue",
      "tierLevel": 9,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Blue9"
    },
    {
      "titanLevel": 21,
      "xp": 269100,
      "xpCumulative": 1500700,
      "tierPhase": "Purple",
      "tierLevel": 0,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple0"
    },
    {
      "titanLevel": 22,
      "xp": 310400,
      "xpCumulative": 1811100,
      "tierPhase": "Purple",
      "tierLevel": 1,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple1"
    },
    {
      "titanLevel": 23,
      "xp": 355000,
      "xpCumulative": 2166100,
      "tierPhase": "Purple",
      "tierLevel": 2,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple2"
    },
    {
      "titanLevel": 24,
      "xp": 402900,
      "xpCumulative": 2569000,
      "tierPhase": "Purple",
      "tierLevel": 3,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple3"
    },
    {
      "titanLevel": 25,
      "xp": 453300,
      "xpCumulative": 3022300,
      "tierPhase": "Purple",
      "tierLevel": 4,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple4"
    },
    {
      "titanLevel": 26,
      "xp": 523800,
      "xpCumulative": 3546100,
      "tierPhase": "Purple",
      "tierLevel": 5,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple5"
    },
    {
      "titanLevel": 27,
      "xp": 602100,
      "xpCumulative": 4148200,
      "tierPhase": "Purple",
      "tierLevel": 6,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple6"
    },
    {
      "titanLevel": 28,
      "xp": 688800,
      "xpCumulative": 4837000,
      "tierPhase": "Purple",
      "tierLevel": 7,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple7"
    },
    {
      "titanLevel": 29,
      "xp": 784200,
      "xpCumulative": 5621200,
      "tierPhase": "Purple",
      "tierLevel": 8,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple8"
    },
    {
      "titanLevel": 30,
      "xp": 888500,
      "xpCumulative": 6509700,
      "tierPhase": "Purple",
      "tierLevel": 9,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Purple9"
    },
    {
      "titanLevel": 31,
      "xp": 1002100,
      "xpCumulative": 7511800,
      "tierPhase": "Golden",
      "tierLevel": 0,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden0"
    },
    {
      "titanLevel": 32,
      "xp": 1124900,
      "xpCumulative": 8636700,
      "tierPhase": "Golden",
      "tierLevel": 1,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden1"
    },
    {
      "titanLevel": 33,
      "xp": 1256800,
      "xpCumulative": 9893500,
      "tierPhase": "Golden",
      "tierLevel": 2,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden2"
    },
    {
      "titanLevel": 34,
      "xp": 1397600,
      "xpCumulative": 11291100,
      "tierPhase": "Golden",
      "tierLevel": 3,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden3"
    },
    {
      "titanLevel": 35,
      "xp": 1546800,
      "xpCumulative": 12837900,
      "tierPhase": "Golden",
      "tierLevel": 4,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden4"
    },
    {
      "titanLevel": 36,
      "xp": 1703500,
      "xpCumulative": 14541400,
      "tierPhase": "Golden",
      "tierLevel": 5,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden5"
    },
    {
      "titanLevel": 37,
      "xp": 1866500,
      "xpCumulative": 16407900,
      "tierPhase": "Golden",
      "tierLevel": 6,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden6"
    },
    {
      "titanLevel": 38,
      "xp": 2034400,
      "xpCumulative": 18442300,
      "tierPhase": "Golden",
      "tierLevel": 7,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden7"
    },
    {
      "titanLevel": 39,
      "xp": 2205000,
      "xpCumulative": 20647300,
      "tierPhase": "Golden",
      "tierLevel": 8,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden8"
    },
    {
      "titanLevel": 40,
      "xp": 2375800,
      "xpCumulative": 23023100,
      "tierPhase": "Golden",
      "tierLevel": 9,
      "phaseAttackCumulative": 27359,
      "phaseHpCumulative": 402854,
      "phaseDefenseCumulative": 2,
      "phaseAndLevel": "Golden9"
    },
    {
      "titanLevel": 41,
      "xp": 2755900,
      "xpCumulative": 25779000,
      "phaseAndLevel": ""
    },
    {
      "titanLevel": 42,
      "xp": 3114200,
      "xpCumulative": 28893200,
      "phaseAndLevel": ""
    },
    {
      "titanLevel": 43,
      "xp": 3425600,
      "xpCumulative": 32318800,
      "phaseAndLevel": ""
    },
    {
      "titanLevel": 44,
      "xp": 3665400,
      "xpCumulative": 35984200,
      "phaseAndLevel": ""
    },
    {
      "titanLevel": 45,
      "xp": 3812000,
      "xpCumulative": 39796200,
      "phaseAndLevel": ""
    }
  ],
  "evolution": {
    "phaseField": "tierPhase",
    "evolutionLevelField": "tierLevel",
    "timeline": [
      {
        "titanLevel": 1,
        "phase": "Green",
        "evolutionLevel": 0,
        "phaseAndLevel": "Green0"
      },
      {
        "titanLevel": 2,
        "phase": "Green",
        "evolutionLevel": 1,
        "phaseAndLevel": "Green1"
      },
      {
        "titanLevel": 3,
        "phase": "Green",
        "evolutionLevel": 2,
        "phaseAndLevel": "Green2"
      },
      {
        "titanLevel": 4,
        "phase": "Green",
        "evolutionLevel": 3,
        "phaseAndLevel": "Green3"
      },
      {
        "titanLevel": 5,
        "phase": "Green",
        "evolutionLevel": 4,
        "phaseAndLevel": "Green4"
      },
      {
        "titanLevel": 6,
        "phase": "Green",
        "evolutionLevel": 5,
        "phaseAndLevel": "Green5"
      },
      {
        "titanLevel": 7,
        "phase": "Green",
        "evolutionLevel": 6,
        "phaseAndLevel": "Green6"
      },
      {
        "titanLevel": 8,
        "phase": "Green",
        "evolutionLevel": 7,
        "phaseAndLevel": "Green7"
      },
      {
        "titanLevel": 9,
        "phase": "Green",
        "evolutionLevel": 8,
        "phaseAndLevel": "Green8"
      },
      {
        "titanLevel": 10,
        "phase": "Green",
        "evolutionLevel": 9,
        "phaseAndLevel": "Green9"
      },
      {
        "titanLevel": 11,
        "phase": "Blue",
        "evolutionLevel": 0,
        "phaseAndLevel": "Blue0"
      },
      {
        "titanLevel": 12,
        "phase": "Blue",
        "evolutionLevel": 1,
        "phaseAndLevel": "Blue1"
      },
      {
        "titanLevel": 13,
        "phase": "Blue",
        "evolutionLevel": 2,
        "phaseAndLevel": "Blue2"
      },
      {
        "titanLevel": 14,
        "phase": "Blue",
        "evolutionLevel": 3,
        "phaseAndLevel": "Blue3"
      },
      {
        "titanLevel": 15,
        "phase": "Blue",
        "evolutionLevel": 4,
        "phaseAndLevel": "Blue4"
      },
      {
        "titanLevel": 16,
        "phase": "Blue",
        "evolutionLevel": 5,
        "phaseAndLevel": "Blue5"
      },
      {
        "titanLevel": 17,
        "phase": "Blue",
        "evolutionLevel": 6,
        "phaseAndLevel": "Blue6"
      },
      {
        "titanLevel": 18,
        "phase": "Blue",
        "evolutionLevel": 7,
        "phaseAndLevel": "Blue7"
      },
      {
        "titanLevel": 19,
        "phase": "Blue",
        "evolutionLevel": 8,
        "phaseAndLevel": "Blue8"
      },
      {
        "titanLevel": 20,
        "phase": "Blue",
        "evolutionLevel": 9,
        "phaseAndLevel": "Blue9"
      },
      {
        "titanLevel": 21,
        "phase": "Purple",
        "evolutionLevel": 0,
        "phaseAndLevel": "Purple0"
      },
      {
        "titanLevel": 22,
        "phase": "Purple",
        "evolutionLevel": 1,
        "phaseAndLevel": "Purple1"
      },
      {
        "titanLevel": 23,
        "phase": "Purple",
        "evolutionLevel": 2,
        "phaseAndLevel": "Purple2"
      },
      {
        "titanLevel": 24,
        "phase": "Purple",
        "evolutionLevel": 3,
        "phaseAndLevel": "Purple3"
      },
      {
        "titanLevel": 25,
        "phase": "Purple",
        "evolutionLevel": 4,
        "phaseAndLevel": "Purple4"
      },
      {
        "titanLevel": 26,
        "phase": "Purple",
        "evolutionLevel": 5,
        "phaseAndLevel": "Purple5"
      },
      {
        "titanLevel": 27,
        "phase": "Purple",
        "evolutionLevel": 6,
        "phaseAndLevel": "Purple6"
      },
      {
        "titanLevel": 28,
        "phase": "Purple",
        "evolutionLevel": 7,
        "phaseAndLevel": "Purple7"
      },
      {
        "titanLevel": 29,
        "phase": "Purple",
        "evolutionLevel": 8,
        "phaseAndLevel": "Purple8"
      },
      {
        "titanLevel": 30,
        "phase": "Purple",
        "evolutionLevel": 9,
        "phaseAndLevel": "Purple9"
      },
      {
        "titanLevel": 31,
        "phase": "Golden",
        "evolutionLevel": 0,
        "phaseAndLevel": "Golden0"
      },
      {
        "titanLevel": 32,
        "phase": "Golden",
        "evolutionLevel": 1,
        "phaseAndLevel": "Golden1"
      },
      {
        "titanLevel": 33,
        "phase": "Golden",
        "evolutionLevel": 2,
        "phaseAndLevel": "Golden2"
      },
      {
        "titanLevel": 34,
        "phase": "Golden",
        "evolutionLevel": 3,
        "phaseAndLevel": "Golden3"
      },
      {
        "titanLevel": 35,
        "phase": "Golden",
        "evolutionLevel": 4,
        "phaseAndLevel": "Golden4"
      },
      {
        "titanLevel": 36,
        "phase": "Golden",
        "evolutionLevel": 5,
        "phaseAndLevel": "Golden5"
      },
      {
        "titanLevel": 37,
        "phase": "Golden",
        "evolutionLevel": 6,
        "phaseAndLevel": "Golden6"
      },
      {
        "titanLevel": 38,
        "phase": "Golden",
        "evolutionLevel": 7,
        "phaseAndLevel": "Golden7"
      },
      {
        "titanLevel": 39,
        "phase": "Golden",
        "evolutionLevel": 8,
        "phaseAndLevel": "Golden8"
      },
      {
        "titanLevel": 40,
        "phase": "Golden",
        "evolutionLevel": 9,
        "phaseAndLevel": "Golden9"
      }
    ],
    "phases": [
      {
        "phase": "Green",
        "minTitanLevel": 1,
        "maxTitanLevel": 10,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Blue",
        "minTitanLevel": 11,
        "maxTitanLevel": 20,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Purple",
        "minTitanLevel": 21,
        "maxTitanLevel": 30,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      {
        "phase": "Golden",
        "minTitanLevel": 31,
        "maxTitanLevel": 40,
        "evolutionLevels": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      }
    ]
  }
};
